module.exports = __webpack_public_path__ + "img/Wallet__active.521c28e0.svg";